module.exports = __webpack_public_path__ + "img/webdvlp_home.a8e71fae.png";